// ---------------------------------------------------------------------------
// Documentation (router) — escolhe a view de Documentation conforme a
// implementacao.
// ---------------------------------------------------------------------------
// Mirror exato do padrao de `Inputs.js`: o menu lateral expoe um unico
// item ``Documentation`` (path ``/documentation``). Aqui decidimos se
// rendermos a V2 (legacy ``DocumentationV2``, accordion aninhado vindo
// de ``api/documentation/``) ou a V3 (``DocumentationV3``, rail + scroll
// spy + mock data por enquanto — leva inicial do "Documentation V3").
//
// Gating: feature flag ``inputs_v3`` reaproveitada. Documentation V3
// depende dos primitivos do Inputs V3 (BlockV3.compute_source_hash etc),
// entao so faz sentido para implementacoes que ja sao V3. Se no futuro
// for necessario desacoplar, criar feature flag ``documentation_v3``
// propria.
// ---------------------------------------------------------------------------

import React, { useContext } from "react";
import AuthContext from "../../contexts/AuthProvider";
import DocumentationV2 from "./DocumentationV2";
import DocumentationV3 from "./DocumentationV3";

const Documentation = (props) => {
  const { userDetails } = useContext(AuthContext);
  const hasV3 = (userDetails?.features || []).includes("inputs_v3");
  const Component = hasV3 ? DocumentationV3 : DocumentationV2;
  return <Component {...props} />;
};

export default Documentation;
